// Cellery Soapbox — responsive breakpoint literals (shared JS/CSS source).
//
// CSS `@media` conditions cannot read custom properties, so these values are
// duplicated as literals in `theme.css`. Keep the two in sync: the "Responsive
// tiers" legend at the top of `theme.css` mirrors this table.
//
//   COMPACT_TOOLBAR_MAX  viewer toolbar secondary actions (Comments/Present/
//                   Share/More) drop their labels to icon-only. Trust and Edit
//                   keep their labels at every width.
//   ONE_COLUMN_MAX  viewer/workspace collapse to a single column; slide rail
//                   becomes a drawer; Doc/Comments toggle appears.
//   PHONE_MAX       phone-scale chrome: header condensation, toolbar "More"
//                   menu, workspace rail drawer, folder-indent step.
//   XS_MAX          extra-small tweaks: hide email + viewer title, tighter pads.

export const COMPACT_TOOLBAR_MAX = 1100;
export const ONE_COLUMN_MAX = 860;
export const PHONE_MAX = 600;
export const XS_MAX = 400;

export const COMPACT_TOOLBAR_QUERY = `(max-width: ${COMPACT_TOOLBAR_MAX}px)`;
export const ONE_COLUMN_QUERY = `(max-width: ${ONE_COLUMN_MAX}px)`;
export const PHONE_QUERY = `(max-width: ${PHONE_MAX}px)`;
export const COARSE_POINTER_QUERY = "(hover: none), (pointer: coarse)";
